<script setup>
import AdminLayout from '@/layouts/AdminLayout.vue'
import { ref } from 'vue'
import ScheduledReportList from '@/views/Admin/Reports/ScheduledReports/ScheduledReportList.vue'
import ScheduledReportLogList from '@/views/Admin/Reports/ScheduledReports/ScheduledReportLogList.vue'
import PendingReportsList from '@/views/Admin/Reports/ScheduledReports/PendingReportsList.vue'

const tabs = [
	{ name: 'Reports' },
	{ name: 'Pending Reports' },
	{ name: 'Logs' },
]
const currentTabIndex = ref(0)

function tabSelected(tabIndex) {
	currentTabIndex.value = tabIndex
}

</script>

<template>
	<AdminLayout>
		<nav class="flex border-b border-neutral-subtle py-2">
			<ul role="list" class="flex min-w-full flex-none gap-x-8 px-2 text-lg font-semibold text-grayscale-body-light">
				<li v-for="(tab, index) in tabs" :key="tab.name">
					<span class="cursor-pointer" :class="currentTabIndex === index ? 'text-information' : 'hover:text-grayscale-body'" @click="tabSelected(index)">{{ tab.name }}</span>
				</li>
			</ul>
		</nav>
		<div class="mt-5" v-if="currentTabIndex === 0">
			<ScheduledReportList />
		</div>
		<div class="mt-5" v-if="currentTabIndex === 1">
			<PendingReportsList />
		</div>
		<div class="mt-5" v-if="currentTabIndex === 2">
			<ScheduledReportLogList />
		</div>
	</AdminLayout>

</template>

<style scoped>

</style>